import React from 'react'
import { Image } from 'antd'
import { Link } from 'react-router-dom'
import icon from '../assets/icons/icon.gif'
import logo from '../assets/images/logo.png'
import logoBlack from '../assets/images/logo-black.png'

type LogoProps = {
  path?: string,
  black?: boolean,
  imgClass?: string,
  className?: string,
}

function Logo({ path, imgClass, className, black }: LogoProps) {
  return (
    <Link to={path || "/"} className={'block '.concat(className!)}>
      <Image className={'w-auto '.concat(imgClass!)} alt='logo' src={black ? logoBlack : logo} preview={false} />
    </Link>
  )
}

type IconProps = {
  path?: string,
  iconClass?: string,
  className?: string,
}

export function Icon({ path, iconClass, className }: IconProps) {
  return (
    <Link to={path!} className={'block '.concat(className!)}>
      <Image className={'w-auto '.concat(iconClass!)} alt='icon' src={icon} preview={false} />
    </Link>
  )
}

export default Logo